import round from './round';

const getMwst = (gesamtpreis) => {
  return round((gesamtpreis / 119) * 7);
};

export default getMwst;
